import {useAlert} from "@/utils/alert";
import {useMberStore} from "@/store/mber";

const initAxiosInterceptor = (axios) => {
  axios.interceptors.request.use(
    function(config) {
      // 요청을 보내기 전에 수행할 로직
      return config;
    },
    function(error) {
      // 요청이 실패한 경우 처리할 로직
      return Promise.reject(error);
    });

// 응답 인터셉터 추가
  axios.interceptors.response.use(
    function(response) {
      // 응답을 받은 후 수행할 로직
      return response;
    },
    async function(error) {
      const $alert = useAlert();
      const $mber = useMberStore();
      // 응답이 실패한 경우 처리할 로직
      const { status } = error.response;

      if (status === 401) {
        $mber.clear();
        await $alert('로그인 정보가 없습니다. 다시 로그인해주세요.');
        location.href = '/portal/views';
      }

      return Promise.reject(error);
    });
}

export default initAxiosInterceptor;
